// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lIVg","name":"styles_name__1FKtk","phone":"styles_phone__230a8"};